module.exports = __webpack_public_path__ + "static/media/foodHouse.00b2a5ad.png";